import { render, staticRenderFns } from "./3_ProdutosPromocao.vue?vue&type=template&id=789dfac0&"
import script from "./3_ProdutosPromocao.vue?vue&type=script&lang=js&"
export * from "./3_ProdutosPromocao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports